import apiClient from './client'
import { Project } from '../types'

export const getProjects = async (): Promise<Project[]> => {
  const response = await apiClient.get('/api/projects')
  
  // Handle both new and legacy API responses
  if (Array.isArray(response)) {
    return response as Project[]
  }
  
  if (response.data && Array.isArray(response.data)) {
    return response.data as Project[]
  }
  
  throw new Error('Invalid API response format')
}

export const getProject = async (id: number): Promise<Project> => {
  const response = await apiClient.get(`/api/projects/${id}`)
  
  // Handle both new and legacy API responses
  if (response.data) {
    return response.data as Project
  }
  
  if ((response as any).id) {
    return response as unknown as Project
  }
  
  throw new Error('Project not found')
}

export const createProject = async (projectData: Omit<Project, 'id' | 'created_at'>): Promise<Project> => {
  const response = await apiClient.post('/api/projects', projectData)
  
  if ((response as any).data?.id) {
    return getProject(Number((response as any).data.id))
  }
  
  if ((response as any).id) {
    return getProject(Number((response as any).id))
  }
  
  throw new Error('Failed to create project')
}

export const updateProject = async (id: number, projectData: Partial<Project>): Promise<void> => {
  await apiClient.put(`/api/projects/${id}`, projectData)
}

export const deleteProject = async (id: number): Promise<void> => {
  await apiClient.delete(`/api/projects/${id}`)
} 